<template>
  <div class="w-full cursor-pointer">
    <span class="flex place-items-center">
      <AtomIconArrowLeft class="flex mr-6 w-3 h-3" />
      <div class="flex place-items-center font-bold leading-10 border-b-2 hover:border-app-green border-transparent uppercase">
        {{ title }}
      </div>
    </span>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string
  url?: string
}

defineProps<Props>()
</script>
